<template lang="pug">
  include ./../../../mixins
  div
    router-module()
    +b.pa--t_md.--b_md.SECTION
      +b.ug-container--variant_large
        +b.ug-row--apearance_spaced.--space_md.--align_center
          +b.ug-cell
            +b.button--go-back.ROUTER-LINK(
              v-if="this.$route.params.from === 'statistics'"
              :to="{ name: 'StatisticsCabinet' }"
            ): +b.icon--type_prev
            +b.button--go-back.ROUTER-LINK(
              v-if="this.$route.params.from === 'order'"
              :to="{ name: 'OrderHistoryCabinet' }"
            ): +b.icon--type_prev
            +b.button--go-back.ROUTER-LINK(
              v-if="this.$route.params.from === 'balance'"
              :to="{ name: 'BalanceHistoryCabinet' }"
            ): +b.icon--type_prev
          +b.ug-cell
            +b.TEXT-BEMTO(
              :fw="'bold'"
              :lh="'initial'"
              :fs="'xl'"
              :color="'black'"
              :tag="'p'"
            ) ORDER ID {{ $route.params.id }}
        +b.pa--f_md.bg--white.ma--t_md
          +b.ug-row--apearance_spaced.--space_md
            +b.ug-cell.ug-cols--12.--6-md.--4-lg.--3-xl
              +b.control-cabinet
                +e.label Uuid:
                +e.element--centered {{ formData.uuid || '-'}}
            +b.ug-cell.ug-cols--12.--6-md.--4-lg.--3-xl
              +b.control-cabinet
                +e.label Prepayment:
                +e.element--centered {{ formData.prepayment || '-'}}
            +b.ug-cell.ug-cols--12.--6-md.--4-lg.--3-xl
              +b.control-cabinet
                +e.label Car registration:
                +e.element--centered {{ formData.carRegistration || '-'}}
            +b.ug-cell.ug-cols--12.--6-md.--4-lg.--3-xl
              +b.control-cabinet
                +e.label Postal Code:
                +e.element--centered {{ formData.postCode || '-'}}
            +b.ug-cell.ug-cols--12.--8-lg.--6-xl.--3-mac
              +b.ug-row--apearance_spaced.--space_md.--align_end
                +b.ug-cell.ug-cols--12.--6-sm.--6-xl.--6-mac.--7-fhd
                  +b.control-cabinet
                    +e.label Date at:
                    +e.element--centered.--date {{ formData.bookingDate || '-'}}
                +b.ug-cell.ug-cols--12.--6-sm.--6-xl.--6-mac.--5-fhd
                  +b.control-cabinet
                    +e.element--centered.--time {{ formData.bookingTime || '-'}}
            +b.ug-cell.ug-cols--12.--6-md.--4-lg.--3-xl
              +b.control-cabinet
                +e.label Responsible:
                +e.element--centered {{ formData.responsibleName || '-'}}
            +b.ug-cell.ug-cols--12.--6-md.--4-lg.--3-xl
              +b.control-cabinet
                +e.label Phone:
                +e.element--centered {{ formData.phone || '-'}}
            +b.ug-cell.ug-cols--12.--6-md.--4-lg.--3-xl
              +b.control-cabinet
                +e.label Service:
                +e.element--centered {{ formData.serviceName || '-'}}
            +b.ug-cell.ug-cols--12.--6-md.--4-lg.--3-xl
              +b.control-cabinet
                +e.label Price:
                +e.element--centered {{ formData.price || '-'}}
            +b.ug-cell.ug-cols--12.--6-md.--4-lg.--3-xl
              +b.control-cabinet
                +e.label Full name:
                +e.element--centered {{ formData.name || '-'}}
            +b.ug-cell.ug-cols--12.--6-md.--4-lg.--3-xl
              +b.control-cabinet
                +e.label House Number And Street
                +e.element--centered {{ formData.address || '-'}}
            +b.ug-cell.ug-cols--12.--6-md.--4-lg.--3-xl
              +b.control-cabinet
                +e.label Is paid:
                +e.element--centered {{ formData.isPaid }}
</template>

<script>
import {
  getBalanceDetailsAPI,
} from '@/js/services/cabinet'

export default {
  name: 'BalanceDetailsCabinet',
  created() {
    this.getBalanceDetailsAPI(
      this.$route.params.id
    )
  },
  data() {
    return {
      formData: {},
    }
  },
  methods: {
    getBalanceDetailsAPI(ID) {
      return getBalanceDetailsAPI.execute(
        { pk: ID }
      )
        .then(response => {
          this.formData = response.data.item
        })
    },
  },
}
</script>



// WEBPACK FOOTER //
// src/js/components/Pages/Cabinet/BalanceDetailsCabinet.vue